module.exports = __webpack_public_path__ + "media/images/map-icons/carASelected-64815f4d0ce72ed183e78eaa7d229e38.png";